import { StylishNewCheckbox } from 'components/DesignSystems/New/StylishNewCheckbox';
import { IconButton } from 'components/DesignSystems/buttons/IconButton';
import { Layer } from './Layer';
import { PowerOutageLayerBody } from './OutageLayerBodies';
import {
  POWER_OUTAGE_LAYER_TITLE,
  usePowerOutageLayerControls,
} from './useOutageLayerControls';

/**
 * Layers tab row for the county-level "Power Outages" choropleth (classic
 * Bootstrap panel).
 */
export function PowerOutageLayerItem() {
  const controls = usePowerOutageLayerControls();

  return (
    <Layer.Item
      eventKey="power-outage-layer"
      header={
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center gap-2">
            <StylishNewCheckbox
              className="mt-0"
              checked={controls.isVisible}
              onClick={(e) => {
                e.stopPropagation();
                controls.toggleVisibility();
              }}
            />
            <span className="fw-semibold">{POWER_OUTAGE_LAYER_TITLE}</span>
          </div>
          <IconButton
            iconProps={{ iconName: 'map' }}
            onClick={(e) => {
              e.stopPropagation();
              controls.zoomToLayer();
            }}
            aria-label="Zoom to power outages"
            title="Zoom to power outages"
            disabled={controls.zoomDisabled}
          />
        </div>
      }
    >
      <Layer.Content>
        <PowerOutageLayerBody controls={controls} />
      </Layer.Content>
    </Layer.Item>
  );
}
